import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { normalizeLanguage } from "./localePaths";

// Import translations files
import en from "../locales/en/translation.json";
import ptBR from "../locales/pt-BR/translation.json";
import es from "../locales/es/translation.json";
import de from "../locales/de/translation.json";
import fr from "../locales/fr/translation.json";

const resources = {
  en: {
    translation: en,
  },
  "pt-BR": {
    translation: ptBR,
  },
  es: {
    translation: es,
  },
  de: {
    translation: de,
  },
  fr: {
    translation: fr,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    // Only these codes are real locales. NOTE: do NOT use
    // nonExplicitSupportedLngs here — with a region-qualified entry like
    // "pt-BR" it strips the requested code to its base ("pt"), which isn't in
    // the list and has no resources, so pt-BR silently falls back to English.
    // Region collapsing for browser-detected codes (en-US -> en, es-ES -> es,
    // pt-PT -> pt-BR) is handled by convertDetectedLanguage below instead.
    supportedLngs: ["en", "pt-BR", "es", "de", "fr"],
    debug: process.env.REACT_APP_ENV === "development",
    react: {
      useSuspense: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      // Normalize detected codes (e.g. navigator "en-US" -> "en",
      // "es-ES" -> "es", "pt-PT" -> "pt-BR") to a supported locale so a
      // regional browser resolves correctly instead of leaking "en-US".
      convertDetectedLanguage: (lng) => normalizeLanguage(lng),
    },
    pluralSeparator: "_",
    contextSeparator: "_",
  });

export default i18n;
